import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { IRestaurantsByIDsCustomersForGames } from 'types';
import {
	IGameAssignmentContext,
	GameAssignmentContext,
} from '../../../../../gameAssignmentState/gameAssignmentContext';
import { AssignImg } from 'components/AssignImg/AssignImg';
import { Checkbox } from 'antd';
import classNames from 'classnames';
import style from './Restaurant.module.scss';

interface IRestaurant {
	data: IRestaurantsByIDsCustomersForGames[];
}

const Restaurant: React.FC<IRestaurant> = ({ data }) => {
	const { setIDsSelectedRestaurants, IDsSelectedRestaurants } =
		useContext<IGameAssignmentContext>(GameAssignmentContext);

	const handleChange = (isChecked: boolean, restaurantID: string) => {
		if (isChecked) {
			const copyIDsSelectedRestaurants = { ...IDsSelectedRestaurants };
			copyIDsSelectedRestaurants[restaurantID] = true;
			setIDsSelectedRestaurants(copyIDsSelectedRestaurants, true);
		} else {
			const copyIDsSelectedRestaurants = { ...IDsSelectedRestaurants };
			delete copyIDsSelectedRestaurants[restaurantID];
			setIDsSelectedRestaurants(copyIDsSelectedRestaurants, true);
		}
	};

	return (
		<div className={style.container} data-test="Restaurant">
			{data.map((el) => {
				const isChecked = el.restaurantId in IDsSelectedRestaurants;
				const isHaveGame = el.hasGames;
				const itemClasses = classNames(style.item, {
					[style.assign]: isHaveGame,
					[style.isChecked]: isChecked,
				});

				return (
					<div className={itemClasses} key={el.restaurantId + 'mainDisplayRestaurantItem'}>
						<div className={style.imageWrapper}>
							{isHaveGame ? <AssignImg name="assignedGameLabel" /> : null}
						</div>
						<div className={style.name}>
							<Checkbox
								className={style.checkbox}
								onChange={(e) => handleChange(e.target.checked, el.restaurantId)}
								checked={isChecked}
							/>
							<Text translationKey={el.address} withTooltip={true} />
						</div>
					</div>
				);
			})}
		</div>
	);
};

export default Restaurant;
